import { render, staticRenderFns } from "./Temporary.vue?vue&type=template&id=f57a30e4&scoped=true&"
import script from "./Temporary.vue?vue&type=script&lang=js&"
export * from "./Temporary.vue?vue&type=script&lang=js&"
import style0 from "./Temporary.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Temporary.vue?vue&type=style&index=1&id=f57a30e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57a30e4",
  null
  
)

export default component.exports